(function () {
  "use strict";

  var CONTAINER_SELECTOR = ".rte.text-size--regular"; // change if needed
  var SINGLE_OPEN = false; // set true to allow only one open panel at a time
  var OPEN_FIRST_BY_DEFAULT = false; // set false if you don't want first opened

  function log() {
    if (window.console) console.log.apply(console, arguments);
  }
  function warn() {
    if (window.console) console.warn.apply(console, arguments);
  }

  // Utility: create element with optional class and attrs
  function createEl(tag, cls, attrs) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (attrs)
      Object.keys(attrs).forEach(function (k) {
        e.setAttribute(k, attrs[k]);
      });
    return e;
  }

  // Convert one container; idempotent (skips if already converted)
  function convertContainer(container) {
    if (!container || container.dataset.accordionProcessed === "true") {
      return;
    }
    log("Accordion: converting container", container);
    var headers = Array.prototype.slice.call(container.querySelectorAll("h4"));
    if (!headers.length) {
      log("Accordion: no <h4> found in container, skipping.");
      container.dataset.accordionProcessed = "true";
      return;
    }

    // We'll build a new fragment and then replace container contents
    var frag = document.createDocumentFragment();
    var introNodes = [];
    // Collect any leading nodes before the first H4
    var firstHeader = headers[0];
    var cur = container.firstChild;
    while (cur && cur !== firstHeader) {
      var next = cur.nextSibling;
      introNodes.push(cur);
      cur = next;
    }
    if (introNodes.length) {
      var introWrap = createEl("div", "rte-intro");
      introNodes.forEach(function (n) {
        introWrap.appendChild(n);
      });
      frag.appendChild(introWrap);
    }

    var accordion = createEl("div", "accordion");

    headers.forEach(function (hdr, idx) {
      // create item
      var item = createEl("div", "accordion-item");

      // button (preserve header innerHTML)
      var button = createEl("button", "accordion-button", {
        type: "button",
        "aria-expanded": "false",
      });
      var title = createEl("div", "accordion-title");
      title.innerHTML = hdr.innerHTML.replace("Q.", "").replace("4.", "");
      var chevron = createEl("span", "accordion-chevron");
      chevron.innerHTML = `
<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10.228 6.1365L7.50071 8.86377L4.77344 6.1365" stroke="#001B2E" stroke-linecap="round"/>
  <rect x="0.5" y="0.5" width="14" height="14" rx="7" stroke="#001B2E"/>
</svg>`;

      button.appendChild(title);
      button.appendChild(chevron);

      // panel: gather nodes from hdr.nextSibling until next H4
      var panel = createEl("div", "accordion-panel", {
        role: "region",
        "aria-hidden": "true",
      });
      var id =
        "accordion-panel-" + Math.random().toString(36).slice(2, 9) + "-" + idx;
      panel.id = id;
      button.setAttribute("aria-controls", id);

      var ptr = hdr.nextSibling;
      while (
        ptr &&
        !(
          ptr.nodeType === Node.ELEMENT_NODE &&
          ptr.tagName.toLowerCase() === "h4"
        )
      ) {
        var next = ptr.nextSibling;

        if (
          ptr.nodeType === Node.ELEMENT_NODE &&
          ptr.tagName.toLowerCase() === "p"
        ) {
          ptr.innerHTML = ptr.innerHTML.replace(/^\s*A\.\s*/i, "");
        }

        panel.appendChild(ptr); // moves the node
        ptr = next;
      }

      // if nothing in panel, add empty p to keep structure
      if (!panel.childNodes.length) {
        var em = document.createElement("p");
        em.textContent = "";
        panel.appendChild(em);
      }

      // append to item
      item.appendChild(button);
      item.appendChild(panel);
      accordion.appendChild(item);

      // remove the original header from DOM if still present
      if (hdr.parentNode) hdr.parentNode.removeChild(hdr);

      // behavior: click/keyboard
      button.addEventListener("click", function () {
        var isOpen = button.getAttribute("aria-expanded") === "true";
        if (isOpen) {
          closePanel(panel, button);
        } else {
          if (SINGLE_OPEN) {
            Array.prototype.forEach.call(
              accordion.querySelectorAll(".accordion-button"),
              function (ob) {
                if (ob !== button) {
                  var op = document.getElementById(
                    ob.getAttribute("aria-controls")
                  );
                  ob.setAttribute("aria-expanded", "false");
                  if (op) {
                    op.setAttribute("aria-hidden", "true");
                    op.style.maxHeight = null;
                    op.classList.remove("open");
                  }
                }
              }
            );
          }
          openPanel(panel, button);
        }
      });

      button.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
          e.preventDefault();
          button.click();
        }
      });
    });

    frag.appendChild(accordion);
    // replace container content
    container.innerHTML = "";
    container.appendChild(frag);

    // mark processed so we don't reprocess
    container.dataset.accordionProcessed = "true";

    // Optionally open first panel
    if (OPEN_FIRST_BY_DEFAULT) {
      var firstBtn = container.querySelector(".accordion-button");
      if (firstBtn) firstBtn.click();
    }

    log(
      "Accordion: conversion complete. Items:",
      container.querySelectorAll(".accordion-item").length
    );
  }

  function openPanel(panel, button) {
    button.setAttribute("aria-expanded", "true");
    panel.setAttribute("aria-hidden", "false");
    panel.classList.add("open");
    // set measured height to allow CSS transition
    panel.style.maxHeight = `${panel.scrollHeight + 10}px`;
  }
  function closePanel(panel, button) {
    button.setAttribute("aria-expanded", "false");
    panel.setAttribute("aria-hidden", "true");
    panel.style.maxHeight = null;
    panel.classList.remove("open");
  }

  // Main initializer: convert existing containers and observe for new ones / content changes
  function init() {
    // Convert any existing containers
    var containers = Array.prototype.slice.call(
      document.querySelectorAll(CONTAINER_SELECTOR)
    );
    if (containers.length) {
      log("Accordion: Found", containers.length, "container(s) to convert.");
      containers.forEach(convertContainer);
    } else {
      log(
        "Accordion: no containers found on init for selector",
        CONTAINER_SELECTOR
      );
    }

    // Observe document body for later-inserted containers (e.g. AJAX)
    var body = document.body;
    if (!body) {
      warn(
        "Accordion: document.body not available — skipping MutationObserver."
      );
      return;
    }

    var mo = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        // check added nodes for containers or H4s within our selector
        m.addedNodes &&
          m.addedNodes.forEach(function (node) {
            try {
              if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.matches && node.matches(CONTAINER_SELECTOR)) {
                  log(
                    "Accordion: observed new container added to DOM — converting."
                  );
                  convertContainer(node);
                  return;
                }
                // descendant container
                var found =
                  node.querySelector && node.querySelector(CONTAINER_SELECTOR);
                if (found) {
                  log(
                    "Accordion: observed container nested in added node — converting."
                  );
                  Array.prototype.slice
                    .call(node.querySelectorAll(CONTAINER_SELECTOR))
                    .forEach(convertContainer);
                  return;
                }
                // If content was injected into existing container, try to find those containers and convert if not yet done
                var possible =
                  node.querySelector &&
                  node.querySelectorAll &&
                  node.querySelectorAll(CONTAINER_SELECTOR);
                if (possible && possible.length) {
                  Array.prototype.slice
                    .call(possible)
                    .forEach(convertContainer);
                }
              }
            } catch (e) {
              warn("Accordion: error in MutationObserver handler:", e);
            }
          });
      });
    });

    mo.observe(body, { childList: true, subtree: true });

    // Also reflow on resize to keep maxHeight correct for open panels
    window.addEventListener("resize", function () {
      Array.prototype.forEach.call(
        document.querySelectorAll(".accordion-panel.open"),
        function (p) {
          p.style.maxHeight = p.scrollHeight + "px";
        }
      );
    });
  }

  // Run on DOM ready (safe if scripts are injected after)
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})(); // IIFE end

document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll(".mount-product-page product-page .css-slider-dot")
    .forEach((dot) => {
      const index = Number(dot.dataset.index);
      if (index > 11) {
        dot.style.display = "none";
      }
    });
});
